import work1 from "../../assets/work1.jpg";
import work2 from "../../assets/work2.jpg";
import work3 from "../../assets/work3.jpg";
import work4 from "../../assets/work4.jpg";
import work5 from "../../assets/work5.jpg";

export const projectsData = [
    {
        id: 1,
        image: work1,
        title: "Hospital web",
        category: "web",
    },
    {
        id: 2,
        image: work2,
        title: "FlybyBird",
        category: "app",
    },
    {
        id: 3,
        image: work3,
        title: "Database-Management System",
        category: "database",
    },
    {
        id: 4,
        image: work4,
        title: "Covermate",
        category: "app",
    },
    {
        id: 5,
        image: work5,
        title: "Desktop Time Management",
        category: "web",
    },
];

export const projectsNav = [
    {
        name: "all",
    },
    {
        name: "web",
    },
    {
        name: "app",
    },
    {
        name: "database",
    },
];
